module.exports = __webpack_public_path__ + "img/properties-setting.9e34aea4.svg";